// src/Invoice/InvoicesView.tsx
import React from 'react';
import {
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import { ReceiptLong, ReportGmailerrorred } from '@mui/icons-material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { InvoiceOverview } from './InvoiceOverview';
import { UnassignedRecordNumbersOverview } from './UnassignedRecordNumbersOverview';

enum INVOICE_VIEW {
  OVERVIEW = 'overview',
  MISSING = 'missing',
}

export const InvoicesView: React.FC = () => {
  const { currentView } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const view = location.pathname.startsWith('/invoices/missing')
    ? INVOICE_VIEW.MISSING
    : ((currentView as INVOICE_VIEW) ?? INVOICE_VIEW.OVERVIEW);

  return (
    <Grid container spacing={2}>
      <Grid item xs={2}>
        <List>
          <ListItemButton
            onClick={() => navigate(`/invoices/view/${INVOICE_VIEW.OVERVIEW}`)}
          >
            <ListItemIcon>
              <ReceiptLong />
            </ListItemIcon>
            <ListItemText primary='Rechnungen' />
          </ListItemButton>
          <ListItemButton
            onClick={() => navigate(`/invoices/view/${INVOICE_VIEW.MISSING}`)}
          >
            <ListItemIcon>
              <ReportGmailerrorred />
            </ListItemIcon>
            <ListItemText primary='Unbewertete Urkunden' />
          </ListItemButton>
        </List>
      </Grid>

      <Grid item xs={10}>
        <Collapse in={view === INVOICE_VIEW.OVERVIEW}>
          <InvoiceOverview />
        </Collapse>
        <Collapse in={view === INVOICE_VIEW.MISSING}>
          <UnassignedRecordNumbersOverview />
        </Collapse>
      </Grid>
    </Grid>
  );
};
